import { render, staticRenderFns } from "./Writers.vue?vue&type=template&id=74f527c8"
import script from "./Writers.vue?vue&type=script&lang=ts"
export * from "./Writers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports